import {
  FeatureName,
  TextQuestionConfig,
  TextResponseState,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledTextInput } from '../../../../../components/forms';
import { useFormContext } from '../../../../forms';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const TextQuestionExecutionFormOld: RoutineQuestionExecutionForm<
  TextQuestionConfig,
  TextResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TextQuestionConfig,
    TextResponseState
  >
) => {
  const { t } = useTranslation();
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.value ?? ''
    : '';
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.value`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledTextInput
      control={control}
      name={field.name}
      placeholder={t('routines.workflow.execution.optional')}
      textArea={props.config.multiline}
      outlinedTextInput={true}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to TextQuestionExecutionFormBase after feature is fully rolled out
const TextQuestionExecutionFormBase: RoutineQuestionExecutionForm<
  TextQuestionConfig,
  TextResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TextQuestionConfig,
    TextResponseState
  >
) => {
  const { t } = useTranslation();
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.value ?? ''
    : '';
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.value`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledTextInput
      control={control}
      name={field.name}
      placeholder={t('routines.workflow.execution.optional')}
      textArea={props.config.multiline}
      hideBorder
      useCropCircle
    />
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const TextQuestionExecutionForm: RoutineQuestionExecutionForm<
  TextQuestionConfig,
  TextResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TextQuestionConfig,
    TextResponseState
  >
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <TextQuestionExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to TextQuestionExecutionFormBase after feature is fully rolled out
  return <TextQuestionExecutionFormBase {...props} />;
};
